import { CreateElement } from '@src/vue'

import { Component, Prop, Provide } from 'vue-property-decorator'

import { Input } from '@src/elements/input/input'

import { Icon } from '@src/elements/icon/icon'
import { Option } from '@src/elements/select/option'

import './select.sass'

@Component
export class Select extends Input {

  @Provide()
  container = this

  @Prop({ required: false, default: false })
  filter: boolean

  @Prop({ required: false, default: false })
  expandWidthWhenActive: boolean

  protected opened = false

  updated () {
    if (this.$el && !this.opened) {
      this.hasFocus = false
      this.$el.classList.remove('selected')
    }
  }

  onSelect (option: Option) {
    if (option.type === 'single-option') this.closeDropdown()

    this.valueChanged(option.value)
  }

  closeDropdown () {
    this.opened = false
    this.hasFocus = false
  }

  render (h: CreateElement) {
    let styleClasses = [
      ...this.elementStyles,
      ...this.inputStyles
    ]

    return (
      this.renderElement(h, this.selectStyles, this.opened, [
        this.renderElement(h, styleClasses, null, [
          this.renderIcon(h),
          this.renderInput(h, false, true),

          this.renderCaret(h)
        ], this.toggleDropdown),
        this.renderDropdown(h)
      ])
    )
  }

  protected toggleDropdown () {
    this.opened = !this.opened
    this.hasFocus = this.opened
    this.toggleKeyboardEvents(this.opened)
    this.toggleOutsideClickEvent(this.opened)
  }

  protected renderCaret (h: CreateElement) {
    return <div class='right-icon caret-icon'>
      <Icon name={'util/caret-down'} />
    </div>
  }

  protected renderDropdown (h: CreateElement) {
    return (!this.opened) ? null :
      <div class={'dropdown-wrapper'}>
        <div class={'dropdown'}>

          {this.$slots.default}

        </div>
      </div>
  }

  protected onEscape () {
    this.closeDropdown()
  }

  protected onClickOutside () {
    this.closeDropdown()
  }

  protected get selectStyles () {
    let styleClasses = ['select']

    if (this.opened) {
      styleClasses.push('opened')
      if (this.expandWidthWhenActive) styleClasses.push('expand-width')
    }
    if (this.filter) {
      styleClasses.push('filtering-select')
    }
    if (this.readonly) {
      styleClasses.push('readonly')
    }
    return styleClasses
  }

}
